import elementUtils from 'utils/elementUtils';
import rangeUtils from 'utils/rangeUtils';
import utils from 'utils/utils';

function findFirstTextBlock(editor, element) {
    //if first child of body is ul/ol then editable.getChild(0) doesn't return first text block
    if (utils.isTextBlock(element)) {
        return element;
    }
    element = element || editor.editable();
    var range = new CKEDITOR.dom.range(editor.editable());
    range.selectNodeContents(element);
    var walker = new CKEDITOR.dom.walker(range);
    var node;
    while (node = walker.next()) {
        if (utils.isTextBlock(node)) {
            return node;
        }
    }
}

function findFirstNonEmptyTextNode(editor, element) {
    //note that a "guard text node" is not considered empty here.
    //This is inconsistent with elementUtils.isElementTextEmpty.
    //all our uses up till now don't need to ignore guard textnode
    var node,
        result = null;
    element = element || editor.editable();

    var walker = elementUtils.getWalkerForElement(editor, element);
    if (element.type === CKEDITOR.NODE_TEXT && element.getText().length > 0) {
        return element;
    }
    while (node = walker.next()) {
        if (node.type === CKEDITOR.NODE_TEXT && node.getText().length > 0) {
            result = node;
            walker.end();
        }
    }

    return result;
}

function getTextNodeNextToElement(element, shouldGoLeft, editor) {
    var tempRange = editor.createRange();
    var blockParent = utils.getBlockParent(editor.elementPath(element));

    if (shouldGoLeft) {
        tempRange.setStartAt(blockParent, CKEDITOR.POSITION_AFTER_START);
        tempRange.setEndBefore(element);

        return rangeUtils.findLastNonEmptyTextNode(tempRange);
    }

    tempRange.setEndAt(blockParent, CKEDITOR.POSITION_BEFORE_END);
    tempRange.setStartAfter(element);

    return rangeUtils.findFirstNonEmptyTextNode(tempRange);
}

export default {
    findFirstTextBlock: findFirstTextBlock,
    findFirstNonEmptyTextNode: findFirstNonEmptyTextNode,
    getTextNodeNextToElement: getTextNodeNextToElement
};
